import gql from "graphql-tag";
const DELETE_EMAILS_HEADINGS = gql `
  mutation deleteEmailsHeading($id: ID!) {
    deleteEmailsHeading(id: $id) {
      status
    }
  }
`;
export default DELETE_EMAILS_HEADINGS;
